<template>
  <!-- 储值卡 -->
  <div class="box-card">
    <div style="text-align: left">
      <!-- 查询 -->
      <el-form :inline="true" size="small" label-position="right" class="query_form" :model="queryForm"
        @submit.native.prevent>
        <el-form-item label="车牌号：">
          <el-input maxlength="8" :value="queryForm.plate_number" placeholder="请输入车牌号"
            @input="(e) => (queryForm.plate_number = validPlatetoUpperCase(e))" @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="停车场：">
          <el-select popper-class="my-select" clearable v-model="queryForm.parking_id" filterable default-first-option
            placeholder="请选择停车场" @change="onSubmit">
            <el-option v-for="item in parkingList" :key="item.parking_id" :label="item.parking_name"
              :value="item.parking_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地：">
          <el-input maxlength="30" :value="queryForm.address" placeholder="请输入所在地"
            @input="(e) => (queryForm.address = validSpacing(e))" @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item>
          <lbButton icon="chaxun" :fill="true" @click="onSubmit()">查询</lbButton>
        </el-form-item>
      </el-form>
      <le-card title="储值卡">
        <template slot="heard-right">
          <div class="right">
            <lbButton type="info" icon="daoru1" @click="openImportDialog"
              v-if="isShowBtn('bee6f07c136947f78b846d13') || isShowBtn('66e77d4309a34a75b61dfec9')">导入</lbButton>
            <lbButton type="warning" icon="daochu" @click="exportFile"
              v-if="isShowBtn('1a0b2643f506491ca51d498f') || isShowBtn('a1149311a8ca4b1e9df78152')">导出</lbButton>
            <lbButton type="err" icon="shanchu1" @click="deleteStoredCard"
              v-if="isShowBtn('568ac3ed14b04289b8d12ac1') || isShowBtn('c5443b35d6d0459e85ecda38')">删除</lbButton>
            <lbButton icon="xinzeng" @click="showAddStoredCard = true"
              v-if='this.getUserInfo.user_name != "admin" && (isShowBtn("4e0ddbcb02724ac4b118bd97") || isShowBtn("39406620fac54d14a647de13"))'>
              新增</lbButton>
          </div>
        </template>
        <div>
          <!-- 表格 -->
          <!-- 使用插件生产表格 -->
          <!-- <avue-crud :data="tableData" :option="option" :page.sync="page" @selection-change="selectionChange"
            @size-change="sizeChange" @current-change="currentChange">
            <template slot-scope="{row}" slot="parking_name">
              <span>{{ row.parking_name ? row.parking_name : '/' }}</span>
            </template>
            <template slot-scope="{row}" slot="car_owner_card_type">
              <span>{{ getWayName("CarOwnerCardType", row.car_owner_card_type) }}</span>
            </template>
            <template slot-scope="{row}" slot="cost_scheme_name">
              <span>{{ row.cost_scheme_name ? row.cost_scheme_name : '/' }}</span>
            </template>
            <template slot-scope="{row}" slot="stored_value_amount">
              {{ row.stored_value_amount.toFixed(2) }}
            </template>
            <template slot-scope="{row}" slot="create_time">
              {{ $moment(row.create_time).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
            <template slot-scope="{row}" slot="menu">
              <lbButton type="succes" icon="chakan" hint="查看" @click="lookStoredCard(row)"></lbButton>
              <lbButton type="warning" icon="bianji" hint="编辑" @click="editStoredCard(row._id)"
                v-if="isShowBtn('bcd83ed28bed4b2eb6aaf6aa') || isShowBtn('b8f7e2c23f794850a3e0538d')"></lbButton>
              <lbButton icon="xufei" hint="充值" @click="rechangeStoredCard(row._id)"
                v-if="isShowBtn('1a0b2643f920400ca81d300f') || isShowBtn('62e232fc46e949bda28bed12')"></lbButton>
            </template>
          </avue-crud> -->
          <el-table class="tablestyle" ref="multipleTable" :data="tableData" align="center" header-align="center"
            tooltip-effect="dark" border stripe @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50" align="center" header-align="center"></el-table-column>
            <el-table-column prop="plate_number" label="车牌号"></el-table-column>
            <el-table-column label="停车场" min-width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.parking_name ? scope.row.parking_name : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="卡类型">
              <template slot-scope="scope">
                <span>{{ getWayName("CarOwnerCardType", scope.row.car_owner_card_type) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计费方案" min-width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.cost_scheme_name ? scope.row.cost_scheme_name : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="stored_value_amount" label="余额（元）">
              <template slot-scope="scope">{{ scope.row.stored_value_amount.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column label="创建时间" width="150">
              <template slot-scope="scope">
                {{ $moment(scope.row.create_time).format('YYYY-MM-DD HH:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <lbButton type="succes" icon="chakan" hint="查看" @click="lookStoredCard(scope.row)"></lbButton>
                <lbButton type="warning" icon="bianji" hint="编辑" @click="editStoredCard(scope.row._id)"
                  v-if="isShowBtn('bcd83ed28bed4b2eb6aaf6aa') || isShowBtn('b8f7e2c23f794850a3e0538d')"></lbButton>
                <lbButton icon="xufei" hint="充值" @click="rechangeStoredCard(scope.row._id)"
                  v-if="isShowBtn('1a0b2643f920400ca81d300f') || isShowBtn('62e232fc46e949bda28bed12')"></lbButton>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="queryForm.PageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="queryForm.PageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="TotalCount"></el-pagination>
        </div>
      </le-card>
    </div>
    <!-- 导入对话框 -->
    <lebo-dialog append-to-body title="导入" :isShow="isImportDialog" width="30%" @close="closeImportDialog" footerSlot>
      <el-form :model="importForm" :rules="importFormRules" ref="importFormRef" label-width="130px" class="import_form">
        <el-form-item label="停车场：" prop="parking_id">
          <el-select popper-class="my-select" v-model="importForm.parking_id" placeholder="请选择停车场"
            @change="parkingIdChange">
            <el-option v-for="item in originParkinList" :key="item.parking_id" :label="item.parking_name"
              :value="item.parking_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费方案：" prop="cost_scheme_id">
          <el-select popper-class="my-select" v-model="importForm.cost_scheme_id" placeholder="请选择计费方案">
            <el-option v-for="item in bilProSelectList" :key="item._id" :label="item.scheme_name" :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余额不足执行：" prop="end_cost_scheme_id">
          <el-select popper-class="my-select" v-model="importForm.end_cost_scheme_id" placeholder="请选择计费方案">
            <el-option v-for="item in bindOverdueExecutionList" :key="item._id" :label="item.scheme_name"
              :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附件：" prop="remarks">
          <div class="upload_box">
            <el-upload class="logo-upload" action="''" :http-request="upload" :show-file-list="true"
              :file-list="fileList">
              <lbButton type="warning">点击上传</lbButton>
            </el-upload>
            <el-link href="/webmanage/xlsx/储值卡模板.xlsx" download="储值卡模板.xlsx" type="primary"
              style="margin-left: 15px;">下载模板</el-link>
          </div>
        </el-form-item>
        <el-form-item label="失败原因：" v-if="errMsg" class="err_box">
          <div>{{ uploadMsg }}</div>
          <div v-for="(item, index) in errMsg" :key="index">{{ index + 1 }}、{{ item }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <lbButton type="goBack" icon="back" @click="closeImportDialog" v-preventReClick>返 回</lbButton> -->
        <lbButton type="default" fill icon="confirm" @click="sendImport" v-preventReClick>确 定</lbButton>
      </span>
    </lebo-dialog>
    <!-- 新增储值卡 -->
    <lebo-dialog :isShow="showAddStoredCard" width="60%" title="新增储值卡" :footerSlot="true"
      @close="showAddStoredCard = false">
      <addStoredCard v-if="showAddStoredCard" :id="'new'" @closeDialog="closeStordCard"></addStoredCard>
    </lebo-dialog>
    <!-- 编辑储值卡 -->
    <lebo-dialog :isShow="showEditStoredCard" width="60%" title="编辑储值卡" :footerSlot="true"
      @close="showEditStoredCard = false">
      <addStoredCard v-if="showEditStoredCard" :id="dialogStoredCardId" @closeDialog="closeStordCard"></addStoredCard>
    </lebo-dialog>
    <!-- 查看储值卡 -->
    <lebo-dialog class="lookMonthCard" :isShow="showDetailStoredCard" width="60%" title="查看储值卡" :footerSlot="true"
      @close="showDetailStoredCard = false" closeOnClickModal>
      <lookDetailCard :id="dialogStoredCardId" :cardType="dialogStoredCardType" v-if="showDetailStoredCard"
        @closeDialog="closeStordCard"></lookDetailCard>
    </lebo-dialog>
    <!-- 储值卡充值 -->
    <lebo-dialog class="lookMonthCard" :isShow="showRechargeStoredCard" width="60%" title="储值卡充值" :footerSlot="true"
      @close="showRechargeStoredCard = false">
      <storedCardRenewals v-if="showRechargeStoredCard" :id="dialogStoredCardId" @closeDialog="closeStordCard">
      </storedCardRenewals>
    </lebo-dialog>
  </div>
</template>

<script>
import request from '@/api/carmanager'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import addStoredCard from './components/addStordCard/index.vue'
import lookDetailCard from '../components/lookDetailCard/index.vue'
import storedCardRenewals from './components/storedCardRenewals/index.vue'
export default {
  components: { addStoredCard, lookDetailCard, storedCardRenewals },
  data () {
    return {
      // 查询表单
      queryForm: {
        parking_id: null,
        plate_number: '',
        car_owner_card_type: 3,
        PageSize: 10,
        PageIndex: 1,
        address: ''
      },
      // 表格数据
      tableData: [],
      seleteTableData: [],
      TotalCount: 0,
      // 展示导入对话框
      isImportDialog: false,
      // 导入表单
      importForm: {
        parking_id: '', // 停车场id
        cost_scheme_id: '', // 计费方案 id car_owner_card_type!=4时为必填
        end_cost_scheme_id: '', // 过期执行id
        remarks: '', // 附件地址
        car_owner_card_type: 3 // 卡片类型 0:临停车 1:计时卡2:月租卡 3:储值卡 4:贵宾卡
      },
      importFormRules: {
        parking_id: [
          { required: true, message: '请选择停车场', trigger: 'blur' }
        ],
        cost_scheme_id: [
          { required: true, message: '请选择计费方案', trigger: 'blur' }
        ],
        end_cost_scheme_id: [
          { required: true, message: '请选择余额不足执行的计费方案', trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: '请选择附件', trigger: 'blur' }
        ]
      },
      // 计费方案下拉列
      bilProSelectList: [],
      // 余额不足执行下拉列
      bindOverdueExecutionList: [],
      // 文件列表
      fileList: [],
      errMsg: null,
      uploadMsg: '', // 导入结果
      showAddStoredCard: false, // 新增储值卡
      showEditStoredCard: false,
      showDetailStoredCard: false,
      showRechargeStoredCard: false,
      dialogStoredCardId: '', // 储值卡id
      dialogStoredCardType: '', // 储值卡类型type
      // 表格插件配置项
      option: {
        searchMenuSpan: 8,
        header: false,
        delBtn: false, // 行删除按钮
        editBtn: false, // 编辑按钮
        selection: true,
        selectionFixed: false, // 解除选择框冻结
        // searchBtn:false,
        menuAlign: 'left', // 属性对齐方式
        menuHeaderAlign: 'left', // 表头对齐方式
        menu: true,
        menuFixed: false, // 解除操作框冻结
        tip: false,
        column: [
          {
            label: '车牌号',
            prop: 'plate_number'
          }, {
            label: '停车场',
            prop: 'parking_name',
            slot: true
          }, {
            label: '卡类型',
            prop: 'car_owner_card_type',
            slot: true
          }, {
            label: '计费方案',
            prop: 'cost_scheme_name',
            slot: true
          }, {
            label: '余额（元）',
            prop: 'stored_value_amount',
            slot: true
          }, {
            label: '创建时间',
            prop: 'create_time',
            slot: true
          }
        ]
      },
      // 分页器
      page: {
        background: false,
        total: 0,
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  created () {
    if (this.queryStatus === 2) {
      this.queryForm = this.deepClone(this.queryObj)
      console.log(this.queryForm)
    }
    this.fnGetStoredCardList()
  },
  computed: {
    ...mapState(['parkingList', 'queryObj', 'queryStatus', 'originParkinList']),
    ...mapState('menuList', ['isRoutW']),
    ...mapGetters(['getWayName', 'getOptions', 'getUserInfo'])
  },
  mounted () {
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  beforeRouteLeave (to, from, next) {
    this.setQueryObj(this.queryForm)
    this.setQueryStatus(1)
    next()
  },
  destroyed () {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  methods: {
    ...mapActions(['requestPorkingList']),
    ...mapMutations(['setQueryObj', 'setQueryStatus']),
    beforeunloadFn (e) {
      this.setQueryStatus(1)
    },
    // 获取储值卡列表
    async fnGetStoredCardList () {
      const res = await request.cardInfoList(this.queryForm)
      if (res && res.Code === 200) {
        this.tableData = res.Data.DataList
        this.TotalCount = res.Data.TotalCount
      } else {
        this.tableData = []
        this.TotalCount = 0
      }
      this.page.total = res && res.Code === 200 && res.Data ? res.Data.TotalCount : 0
    },
    onSubmit () {
      this.queryForm.PageIndex = 1
      this.fnGetStoredCardList()
    },
    // 每页条数改变
    handleSizeChange (size) {
      this.queryForm.PageSize = size
      this.fnGetStoredCardList()
    },
    // // 每页条数改变
    // sizeChange (val) {
    //   this.page.currentPage = 1
    //   this.page.pageSize = val
    //   this.queryForm.PageSize = val
    //   this.fnGetStoredCardList()
    // },
    // 页码改变
    handleCurrentChange (page) {
      this.queryForm.PageIndex = page
      this.fnGetStoredCardList()
      this.$refs.multipleTable.bodyWrapper.scrollTop = 0
    },
    // // 页码改变
    // currentChange (val) {
    //   this.queryForm.PageIndex = val
    //   this.page.currentPage = val
    //   this.fnGetStoredCardList()
    // },
    // 表格选中项发生改变
    handleSelectionChange (val) {
      this.seleteTableData = val
    },
    // // 选中的数据
    // selectionChange (list) {
    //   this.seleteTableData = list
    // },
    // 删除选中的储值卡
    deleteStoredCard () {
      if (this.seleteTableData.length > 0) {
        this.$confirm('此操作将永久的删除选中的储值卡, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$msg.success('删除成功!');
          var obj = {}
          var arr = []
          for (var i = 0; i < this.seleteTableData.length; i++) {
            arr.push(this.seleteTableData[i]._id)
            if (arr.length === this.seleteTableData.length) {
              obj._ids = arr
              this.fnDelTimeCard(obj)
            }
          }
        }).catch(() => {
          this.$msg.info('已取消删除')
        })
      } else {
        this.$msg.warning('请选择要删除的储值卡！')
      }
    },
    // 删除储值卡请求
    async fnDelTimeCard (obj) {
      const res = await request.deleteCard(obj)
      if (res && res.Code === 200) {
        this.$msg.success(res.Message)
      }
      this.fnGetStoredCardList()
    },
    // 导出储值卡
    async exportFile () {
      const res = await request.cardInfoList({
        parking_id: this.queryForm.parking_id,
        plate_number: this.queryForm.plate_number,
        car_owner_card_type: 3,
        PageSize: 0,
        PageIndex: 0
      })
      // console.log(res.Data.DataList);
      const resultList = res.Data.DataList
      if (resultList.length <= 0) {
        this.$msg.warning('暂无数据！')
      } else {
        // 设置当前日期
        var name = this.$moment(new Date()).format('YYYY-MM-DD')
        // console.log(name);
        import('@/utils/Export2Excel').then((excel) => {
          const tHeader = [
            '车牌号',
            '停车场',
            '卡类型',
            '计费方案',
            '余额（元）',
            '创建时间'
          ]
          const filterVal = [
            'plate_number',
            'parking_name',
            'car_owner_card_type',
            'cost_scheme_name',
            'stored_value_amount',
            'create_time'
          ]
          const list = resultList
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader, //  必填   导出数据的表头
            data, //  必填   导出具体数据
            filename: '储值卡卡片信息' + name, //  非必填   导出文件名
            autoWidth: true, //  非必填   单元格是否自动适应宽度
            bookType: 'xlsx' //  非必填   导出文件类型
          })
        })
      }
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        var map = {}
        this.$set(map, j, v[j])
        return this.formatter(map, { property: j })
        // 为formatter专门为了码表渲染的组件
      })
      )
    },
    // 数据格式化
    formatter (row, column) {
      // console.log(row);
      // console.log(column);
      // 日期处理
      if (column.property === 'create_time') {
        return this.$moment(row[column.property]).format('YYYY-MM-DD HH:mm:ss')
      } else if (column.property === 'car_owner_card_type') {
        return row.car_owner_card_type = this.getWayName('CarOwnerCardType', row.car_owner_card_type)
      } else {
        return row[column.property] ? row[column.property] : '/'
      }
    },
    // 展示导入对话框
    openImportDialog () {
      this.requestPorkingList()
      this.isImportDialog = true
      // console.log(this.originParkinList);
    },
    // 停车场选项发生改变时触发
    parkingIdChange (val) {
      this.fnGetBilProSelectList(val)
      this.fnGetStaleDateBilProSelectList(val)
      this.importForm.cost_scheme_id = ''
      this.importForm.end_cost_scheme_id = ''
    },
    // 停车场绑定计时/计次/时段卡计费方案下拉列
    async fnGetBilProSelectList (id) {
      const res = await request.getBilProSelectList({
        parking_id: id
      })
      if (res && res.Code === 200) {
        this.bilProSelectList = res.Data
      } else {
        this.bilProSelectList = []
      }
    },
    // 过期执行/余额不足下拉列
    async fnGetStaleDateBilProSelectList (id) {
      const res = await request.getBindOverdueExecutionList({
        parking_id: id
      })
      if (res && res.Code === 200) {
        this.bindOverdueExecutionList = res.Data
      } else {
        this.bindOverdueExecutionList = []
      }
    },
    // 上传附件
    async upload (item) {
      var formData = new FormData()
      formData.append('file', item.file)
      const res = await request.uploadFile(formData)
      if (res.data && res.data.length > 0) {
        this.importForm.remarks = res.data[0].FilePath
        this.fileList = [{
          name: res.data[0].FileName,
          url: res.data[0].FilePath
        }]
      }
    },
    // 导入卡片
    sendImport () {
      this.$refs.importFormRef.validate(async (valid) => {
        if (valid) {
          const res = await request.importCard(this.importForm)
          console.log('importCard------', res)
          if (res && res.Code === 200) {
            if (res.Data) {
              this.errMsg = res.Data
            } else {
              // this.$msg.success(res.Message)
              this.isImportDialog = false
            }
            this.uploadMsg = res.Message
            this.onSubmit()
          } else {
            this.errMsg = [res.Message]
          }
          this.fileList = []
          this.importForm.remarks = ''
        } else {
          return false
        }
      })
    },
    // 关闭导入卡片对话框时触发
    closeImportDialog () {
      this.isImportDialog = false
      this.$refs.importFormRef.resetFields()
      this.fileList = []
      this.errMsg = null
      this.bilProSelectList = []
      this.bindOverdueExecutionList = []
      console.log(this.importForm)
    },
    // 关闭弹窗刷新
    closeStordCard () {
      this.showAddStoredCard = false
      this.showEditStoredCard = false
      this.showRechargeStoredCard = false
      this.fnGetStoredCardList()
    },
    // 编辑储值卡
    editStoredCard (row) {
      this.showEditStoredCard = true
      this.dialogStoredCardId = row
    },
    // 查看储值卡
    lookStoredCard (row) {
      this.showDetailStoredCard = true
      this.dialogStoredCardId = row._id
      this.dialogStoredCardType = row.car_owner_card_type
    },
    // 储值卡充值
    rechangeStoredCard (row) {
      this.showRechargeStoredCard = true
      this.dialogStoredCardId = row
    }
  }
}
</script>

<style scoped lang="less">
.box-card {
  margin-top: 20px;
}

.import_form {
  margin: 0 25px;

  /deep/ .el-select {
    width: 100%;
  }
}

.upload_box {
  position: relative;
  display: flex;
  align-items: flex-start;

  .el-link {
    position: absolute;
    left: 100px;
  }
}

.err_box {
  color: #f56666;
  max-height: 320px;
  overflow-y: auto;
  /deep/ .el-form-item__label {
    color: #f56666;
  }

}

.lookMonthCard {
  min-height: 60%;

  /deep/.el-dialog {
    min-height: 60%;

  }
}
</style>
